import FocusShell from "../components/FocusShell";
import Booking from "../components/Booking";

export default function BookFreeVisit() {
  return (
    <FocusShell
      testid="book-free-visit-page"
      title="Book a Free Visit | Reef Deco — Curtains & Blinds Dubai"
      description="Book a free home visit anywhere in Dubai. Our team measures your windows, shows fabric samples and gives you an exact quote — no obligation."
    >
      <Booking />
    </FocusShell>
  );
}
